module.exports = __webpack_public_path__ + "media/bootstrap-icons/card-list-3f2ae3c2.svg";